import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import { ExecutionCost, ExecutionCostRes, GetSymbolsParams, MarketStats, SortedSymbols } from './types';

export const getSortedSymbolsApi = () => apiClient.get<SortedSymbols>('/v2/market/sorted-symbols');
export const fetchSortedSymbolsApi = () => fetchClient.fetch<SortedSymbols>('/v2/market/sorted-symbols');
export const getSymbolsApi = (params?: GetSymbolsParams) =>
  apiClient.get<SortedSymbols>('/v2/market/symbols', { params });

export const getExecutionCostApi = (symbol: string, params: ExecutionCost) =>
  apiClient.get<ExecutionCostRes>(`/v2/market/${symbol}/execution-cost`, {
    params,
  });

export const getMarketStatsApi = (currency: string) => apiClient.get<MarketStats>(`/v2/market/stats/${currency}`);
